import { takeEvery } from 'redux-saga/effects'

import watchLifecycleEvents, { lifecycleActions } from './lifecycleEvents'

export const takes = ([
    takeEvery(lifecycleActions, watchLifecycleEvents),
])

const sagas = {
    takes,
}

export default sagas
